// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// API
import { getProgressionAnalysisComments } from "../../api";

export const useProgressionAnalysisComments = (
  clinicId: string | undefined
) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();

  return useMutation({
    mutationFn: async (params: {
      patientId: string;
      progressionAnalysisId: string;
    }) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        const controller = new AbortController();
        return getProgressionAnalysisComments(
          token,
          clinicId,
          params.patientId,
          params.progressionAnalysisId,
          controller.signal
        );
      } catch (error) {
        throw error;
      }
    },
    // Invalidate query cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: ["progression-analysis-comments"],
      });
    },
  });
};
